import React, { Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import asyncComponent from './hoc/asyncComponent/asyncComponent';
import './App.module.css';
import withClearCache from "./hoc/withClearCache/withClearCache";
import Layout from './hoc/Layout/Layout';
import PatternLibrary from "./containers/PatternLibrary/PatternLibrary";
import GamesReference from "./containers/GamesReference/GamesReference";
import PatternExercises from "./containers/PatternExercises/PatternExercises";
import logout from './containers/Auth/Logout/Logout';
import * as actions from './store/actions/index';



const asyncAuth = asyncComponent(() => {
    return import('./containers/Auth/Auth');
});

const passwordReset = asyncComponent(() => {
    return import('./containers/Auth/PasswordReset');
});

class App extends Component {
    componentDidMount () {
        this.props.onTryAutoSignup();
    }

    render () {

        let routes = (
            <Switch>
                <Route path="/PatternLibraryApp/auth" component={asyncAuth} />
                <Route path="/PatternLibraryApp/logout" component={logout} />
                {!this.props.isAuthenticated && <Route path="/PatternLibraryApp/reset/:token" component={passwordReset}/>}
                <Route path="/PatternLibraryApp/PatternLibrary" exact component={PatternLibrary} />
                <Route path="/PatternLibraryApp/PatternLibrary/:patternId" exact component={PatternLibrary} />
                <Route path="/PatternLibraryApp/GamesReference" exact component={GamesReference} />
                <Route path="/PatternLibraryApp/GamesReference/:gameId" exact component={GamesReference} />
                <Route path="/PatternLibraryApp/PatternExercises/:exerciseId/:executionId" exact component={PatternExercises} />
                <Route path="/PatternLibraryApp/PatternExercises/:exerciseId/" exact component={PatternExercises} />
                <Redirect to="/PatternLibraryApp/PatternLibrary" />
            </Switch>
        );
        //
        // if ( this.props.isAuthenticated ) {
        //     routes = (
        //         <Switch>
        //             <Route path="/PatternLibraryApp/auth" component={asyncAuth} />
        //             <Route path="/PatternLibraryApp/logout" component={logout} />
        //             <Route path="/PatternLibraryApp/PatternLibrary" exact component={PatternLibrary} />
        //             <Route path="/PatternLibraryApp/PatternLibrary/:patternId" exact component={PatternLibrary} />
        //             <Route path="/PatternLibraryApp/GamesReference" exact component={GamesReference} />
        //             <Route path="/PatternLibraryApp/GamesReference/:gameId" exact component={GamesReference} />
        //             <Redirect to="/PatternLibraryApp/PatternLibrary" />
        //         </Switch>
        //     );
        // }

        const WrappedComponent = (<div>
                                    <Layout location={this.props.location}>
                                        {routes}
                                    </Layout>
                                </div>);
        const ComponentWithClearCache = withClearCache(WrappedComponent);

        return (
                <ComponentWithClearCache />
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onTryAutoSignup: () => dispatch( actions.authCheckState() )
    };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( App ) );
